import {INIT_SUCCESS, LOGIN_SUCCESS} from './auth';

const DBINFO_LOAD = '@@DbInfo/DBINFO_LOAD';
const DBINFO_SUCCESS = '@@DbInfo/DBINFO_SUCCESS';
const DBINFO_FAIL = '@@DbInfo/DBINFO_FAIL';

const initialState = {

};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {

		case DBINFO_SUCCESS:
			state[action.name] = action.result;
			return state;

		case LOGIN_SUCCESS:
		case INIT_SUCCESS:
			return action.result.dbinfo;
		
		default:
			return state;
	}
}

export function load(name) {
	return {
		name,
		types: [DBINFO_LOAD, DBINFO_SUCCESS, DBINFO_FAIL],
		promise: (client) => client.call('dbinfo.load', {name})
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/dbinfo.js